export function getViewport() {
 let viewportWidth, viewportHeight;

 if (typeof window.innerWidth !== 'undefined') {
   viewportWidth = window.innerWidth;
   viewportHeight = window.innerHeight;
 }

 return [viewportWidth, viewportHeight];
}



// WEBPACK FOOTER //
// ./src/components/FileInput/utils.js